import { render, staticRenderFns } from "./TCheckbox.vue?vue&type=template&id=29dc5d9c&scoped=true&"
import script from "./TCheckbox.vue?vue&type=script&lang=js&"
export * from "./TCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./TCheckbox.vue?vue&type=style&index=0&id=29dc5d9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dc5d9c",
  null
  
)

/* custom blocks */
import block0 from "./TCheckbox.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports